(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elyon-resenas"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('elyon-reviews')) {
    customElements.define('elyon-reviews', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }
      setup() {
        if (!this.isConnected || this.controller) return;
        this.track = this.querySelector('.elyon-reviews__track');
        if (!this.track) return;
        this.cards = [...this.querySelectorAll('.elyon-reviews__card')];
        this.controls = this.querySelector('.elyon-reviews__controls');
        this.dots = this.querySelector('.elyon-reviews__dots');
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.status = this.querySelector('[data-status]');
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.previous.addEventListener('click', () => this.go(this.active - 1), { signal });
        this.next.addEventListener('click', () => this.go(this.active + 1), { signal });
        this.dots.addEventListener('click', event => {
          const button = event.target.closest('[data-page]');
          if (button) this.go(Number(button.dataset.page));
        }, { signal });
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, { passive: true, signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const target = { ArrowRight: this.active + 1, ArrowLeft: this.active - 1, Home: 0, End: this.targets.length - 1 }[event.key];
          if (target === undefined) return;
          event.preventDefault();
          this.go(target);
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const card = this.cards.find(item => item.dataset.blockId === event.detail?.blockId);
          if (!card) return;
          const left = card.offsetLeft - this.cards[0].offsetLeft;
          this.track.scrollTo({ left, behavior: 'instant' });
        }, { signal });
        this.observer = new ResizeObserver(() => this.build());
        this.observer.observe(this.track);
        this.build();
      }
      build() {
        const columns = Number(getComputedStyle(this.track).getPropertyValue('--er-columns')) || 1;
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.targets = [];
        for (let index = 0; index < this.cards.length; index += columns) {
          const position = Math.min(max, this.cards[index].offsetLeft - this.cards[0].offsetLeft);
          if (!this.targets.length || Math.abs(position - this.targets.at(-1)) > 2) this.targets.push(position);
        }
        this.dots.replaceChildren(...this.targets.map((target, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'elyon-reviews__dot';
          button.dataset.page = index;
          button.setAttribute('aria-label', `${this.dataset.pageLabel} ${index + 1} / ${this.targets.length}`);
          return button;
        }));
        this.controls.hidden = this.targets.length < 2;
        this.update();
      }
      update() {
        const left = Math.max(0, this.track.scrollLeft);
        this.active = this.targets.reduce((best, value, index) => Math.abs(value - left) < Math.abs(this.targets[best] - left) ? index : best, 0);
        const maxDots = this.clientWidth < 370 ? 3 : 5;
        const start = Math.max(0, Math.min(this.active - Math.floor(maxDots / 2), this.targets.length - maxDots));
        [...this.dots.children].forEach((button, index) => {
          button.hidden = index < start || index >= start + maxDots;
          button.setAttribute('aria-current', String(index === this.active));
        });
        this.previous.disabled = this.active === 0;
        this.next.disabled = this.active === this.targets.length - 1;
        this.status.textContent = `${this.dataset.pageLabel} ${this.active + 1} / ${this.targets.length}`;
      }
      go(page) {
        const target = Math.max(0, Math.min(page, this.targets.length - 1));
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({ left: this.targets[target], behavior: reduced ? 'instant' : 'smooth' });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
